const InitFunc = () => {
  if (window.innerWidth <= 768) {
    const mobileMenuButton = window.document.querySelector('.vdMobileMenuIcon');
    const mobileMenu = window.document.querySelector('.mobileMenu');
    mobileMenuButton.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
    });
  }
};

export default {
  platform: 'shift4shop',
  InitFunc,
  searchPageUrl: '/Search_ep_53-1.html',
  SearchRequestDefaults: {
    pageSize: 12,
  },
  Widgets: [
    {
      name: 'SearchPage',
      location: '#cm_searchPage',
      template: 'SearchPage',
    },
    {
      name: 'SearchHeader',
      sortEntries: {
        '_popularity:desc,relevance': 'Popularity',
        'ReviewAverage:desc,ReviewCount:desc': 'Average Rating',
        'ReviewCount:desc': 'Review Count',
        'Price': 'Price: (Low to High)',
        'Price:desc': 'Price (High to Low)',
        'Name': 'By name (A to Z)',
        'Name:desc': 'By name (Z to A)',
      },
      pageSizes: [12, 48, 70, 96],
    },
    {
      name: 'SearchResult',
    },
    {
      name: 'FacetPanel',
    },
    {
      name: 'SearchBoxDialogButton',
      location: '#searchBox',
      template: 'searchBox/dialogButtonAdaptable',
    },
    {
      name: 'FacetDialog',
      template: 'FacetDialog',
    },
    {
      name: 'SearchBoxDialog',
      template: 'SearchBoxDialog',
    },
  ],
};
